const userPlanFood = {
  get: 'UserPlanFood/getlist-by-admin',
}
export default userPlanFood
